import { arena01 } from "./arena01";
import { validateLevelDefinition } from "./types";

export const maps = [arena01];

export function getLevel(id: string) {
  return maps.find((level) => level.id === id) ?? maps[0];
}

export const levelValidationIssues = maps.flatMap(validateLevelDefinition);